import _inject from "@stylexjs/stylex/lib/stylex-inject";
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
import React, { useContext, useEffect, useRef, useState } from 'react';
import FeatherIcon from "../../ui/feather-icon/FeatherIcon";
import dateFormat from "dateformat";
import dt from "date-and-time";
import { date_util } from "noood/util/date/DateUtil";
import * as stylex from '@stylexjs/stylex';
import { ClosestElementRegistryContext } from "noood/contexts/contexts";
export default function CalendarBody(props) {
  var _useState = useState(new Date()),
    _useState2 = _slicedToArray(_useState, 2),
    date_val = _useState2[0],
    set_date_val = _useState2[1];
  var _useState3 = useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    selfPositioningStyle = _useState4[0],
    setSelfPositioningStyle = _useState4[1];
  var thisCalRef = useRef();
  var closestRegistry = useContext(ClosestElementRegistryContext);
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var __month = function __month(index, is_compact) {
    return months[parseInt(index)].substring(0, is_compact ? 3 : months[parseInt(index)].length);
  };
  useEffect(function () {
    var _thisCalRef$current;
    console.log("i will calculate to reposition self...");
    var divPos = (_thisCalRef$current = thisCalRef.current) === null || _thisCalRef$current === void 0 ? void 0 : _thisCalRef$current.getBoundingClientRect();
    console.log(divPos);
    if (divPos) {
      var bottom = divPos.bottom;
      var viewportHeight = window.innerHeight;
      console.log(bottom, viewportHeight);
      if (bottom + 20 > viewportHeight) {
        setSelfPositioningStyle({
          marginTop: "-".concat(divPos.height + 35, "px"),
          visibility: "visible"
        });
      } else {
        setSelfPositioningStyle({
          visibility: "visible"
        });
      }
    }
  }, []);
  useEffect(function () {
    if (thisCalRef) {
      var _closestRegistry$__re;
      closestRegistry === null || closestRegistry === void 0 || (_closestRegistry$__re = closestRegistry.__registerRef) === null || _closestRegistry$__re === void 0 || _closestRegistry$__re.call(closestRegistry, {
        ref: thisCalRef.current
      });
    }
  }, [thisCalRef]);
  useEffect(function () {
    if (props.val) {
      var _date_util$parse;
      set_date_val((_date_util$parse = date_util.parse(props.val)) !== null && _date_util$parse !== void 0 ? _date_util$parse : date_val);
    }
  }, [props.val]);
  var this_month = dt.parse(dateFormat(date_val, 'yyyy-mm-01'), 'YYYY-MM-DD');
  var prev_month = dt.addMonths(this_month, -1);
  var prev_month_last_date = dt.addDays(this_month, -1).getDate();
  var next_month = dt.addMonths(this_month, 1);
  var this_month_last_date = dt.addDays(next_month, -1).getDate();
  var day_one = dateFormat(this_month, 'N');
  var this_year_str = dateFormat(this_month, 'yyyy');
  var this_month_str = dateFormat(this_month, 'mm');
  return /*#__PURE__*/React.createElement("div", {
    className: ['ui-cal', props.compact ? 'ui-cal-compact' : '', {
      className: "CalendarBody__ui.box ev1bkuceq"
    }.className].join(' '),
    id: 'cal-' + props.id,
    ref: thisCalRef,
    style: _objectSpread({
      visibility: "hidden"
    }, selfPositioningStyle)
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      backgroundColor: '#eee',
      borderBottom: 0,
      borderTopLeftRadius: 'var(--roundness)',
      borderTopRightRadius: 'var(--roundness)',
      padding: props.compact ? '3px' : '7px'
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%'
    },
    className: 'ui-cal-ctrls collapsed'
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#e1e1e1',
      cursor: 'pointer',
      width: '30px',
      fontSize: props.compact ? '12px' : '14px',
      padding: '0 5px',
      borderTopLeftRadius: 'var(--roundness)',
      borderBottomLeftRadius: 'var(--roundness)',
      borderRight: '1px solid #d1d1d1'
    }
  }, date_val ? /*#__PURE__*/React.createElement(React.Fragment, null, date_val.getFullYear()) : null), /*#__PURE__*/React.createElement("td", {
    style: {
      backgroundColor: '#e1e1e1',
      fontSize: props.compact ? '12px' : '14px',
      width: '50px',
      padding: '0 5px',
      borderTopRightRadius: 'var(--roundness)',
      borderBottomRightRadius: 'var(--roundness)',
      textAlign: 'center',
      cursor: 'pointer'
    }
  }, date_val ? /*#__PURE__*/React.createElement(React.Fragment, null, __month(date_val.getMonth(), props.compact)) : null), /*#__PURE__*/React.createElement("td", null, "\xA0"), /*#__PURE__*/React.createElement("td", _extends({
    style: {
      width: '10px',
      padding: '0 3px',
      cursor: 'pointer',
      fontSize: '15px',
      borderTopLeftRadius: 'var(--roundness)',
      borderBottomLeftRadius: 'var(--roundness)'
    }
  }, {
    className: "CalendarBody__ui.controls ev1h2kqdt evji57aj ev14abgrs ev1ko5yus"
  }), /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: 'chevron-left',
    onClick: function onClick() {
      set_date_val(prev_month);
    }
  })), /*#__PURE__*/React.createElement("td", _extends({
    style: {
      width: '10px',
      padding: '0 3px',
      cursor: 'pointer',
      fontSize: '11px'
    }
  }, {
    className: "CalendarBody__ui.controls ev1h2kqdt evji57aj ev14abgrs ev1ko5yus"
  }), /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: 'circle',
    onClick: function onClick() {
      set_date_val(new Date());
    }
  })), /*#__PURE__*/React.createElement("td", _extends({
    style: {
      width: '10px',
      padding: '0 3px',
      cursor: 'pointer',
      fontSize: '15px',
      borderTopRightRadius: 'var(--roundness)',
      borderBottomRightRadius: 'var(--roundness)'
    }
  }, {
    className: "CalendarBody__ui.controls ev1h2kqdt evji57aj ev14abgrs ev1ko5yus"
  }), /*#__PURE__*/React.createElement(FeatherIcon, {
    icon: 'chevron-right',
    onClick: function onClick() {
      set_date_val(next_month);
    }
  })))))), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
    className: 'ui-cal-tbl',
    style: {
      borderCollapse: "separate !important"
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Su"), /*#__PURE__*/React.createElement("th", null, "Mo"), /*#__PURE__*/React.createElement("th", null, "Tu"), /*#__PURE__*/React.createElement("th", null, "We"), /*#__PURE__*/React.createElement("th", null, "Th"), /*#__PURE__*/React.createElement("th", null, "Fr"), /*#__PURE__*/React.createElement("th", null, "Sa"))), /*#__PURE__*/React.createElement("tbody", null, Array(5).fill(0).map(function (num, idx) {
    return /*#__PURE__*/React.createElement("tr", {
      key: idx
    }, Array(7).fill(0).map(function (num2, idx2) {
      var matrix_value = 7 * (idx + 1) - (7 - (idx2 + 1)) + (day_one === 7 ? 7 : 0);
      var raw_matrix_value = matrix_value - day_one;
      var final_value = raw_matrix_value <= 0 ? prev_month_last_date + raw_matrix_value : raw_matrix_value > this_month_last_date ? raw_matrix_value - this_month_last_date : raw_matrix_value;
      var this_month_str = raw_matrix_value <= 0 ? dateFormat(prev_month, 'mm') : raw_matrix_value > this_month_last_date ? dateFormat(next_month, 'mm') : dateFormat(this_month, 'mm');
      var the_date = "".concat(this_year_str, "-").concat(this_month_str, "-").concat(parseInt(final_value) < 10 ? '0'.concat(final_value) : final_value);
      var disabled = false;
      if (props.min_date) {
        var min_date = dt.parse(props.min_date, 'YYYY-MM-DD');
        var this_date = dt.parse(the_date, 'YYYY-MM-DD');
        disabled = dt.subtract(this_date, min_date).toDays() < 0;
      }
      if (!disabled && props.max_date) {
        var max_date = dt.parse(props.max_date, 'YYYY-MM-DD');
        var _this_date = dt.parse(the_date, 'YYYY-MM-DD');
        disabled = dt.subtract(_this_date, max_date).toDays() > 0;
      }
      return /*#__PURE__*/React.createElement("td", {
        key: (idx + 1) * (idx2 + 1),
        className: [disabled || raw_matrix_value <= 0 || raw_matrix_value > this_month_last_date ? 'ui-cal-cell-dead' : '', the_date === props.val ? 'ui-cal-selected' : '', the_date === dateFormat(new Date(), 'yyyy-mm-dd') ? {
          className: "CalendarBody__ui.today evji57aj evxwrc4x"
        }.className : '', disabled ? 'ui-cal-cell-disabled' : ''].join(' '),
        onClick: function onClick() {
          if (!disabled) {
            props.set_val(the_date);
            props.set_show(false);
          }
        }
      }, final_value, /*#__PURE__*/React.createElement("br", null));
    }));
  })))));
}
_inject(".ev1bkuceq{border:1px solid var(--shade-20)}", 1000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev14abgrs:hover{background-color:var(--shade-15)}", 3130);
_inject(".ev1ko5yus:active{background-color:var(--shade-20)}", 3170);
_inject(".evxwrc4x{border-radius:var(--roundness)}", 2000);